// Tour progress, kept per user and per portal. This is the only place that knows where it is stored, so it
// can be moved to a backend API later without touching the tour screens.
//
// Stored shape (one record per user):
//   { userId, portal, role, welcomeSeen, tours: { [tourId]: { status, currentStep, totalSteps, completedAt } } }
// status: "in_progress" | "completed"   (a tour with no record is "not started")

const userObj = () => { try { return JSON.parse(sessionStorage.getItem("user") || "{}"); } catch { return {}; } };
const portalName = () => ((sessionStorage.getItem("userType") || "").toLowerCase() === "vendor" ? "vendor" : "admin");

const identity = () => {
  const u = userObj();
  return {
    userId: u.id || u._id || u.userId || u.sellerId || u.empId || u.email || sessionStorage.getItem("email") || "anonymous",
    role: String(u.role || sessionStorage.getItem("role") || ""),
  };
};

const keyFor = () => `tvfm_tour:${portalName()}:${identity().userId}`;

const read = () => {
  const { userId, role } = identity();
  try {
    const raw = localStorage.getItem(keyFor());
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return { ...parsed, tours: parsed.tours || {}, role };
    }
  } catch {}
  return { userId, portal: portalName(), role, welcomeSeen: false, tours: {} };
};

const write = (data) => {
  try { localStorage.setItem(keyFor(), JSON.stringify(data)); } catch {}
};

export const getProgress = () => read();

export const getTourProgress = (tourId) => read().tours[tourId] || null;

export const saveTourProgress = (tourId, { currentStep, totalSteps }) => {
  const data = read();
  const prev = data.tours[tourId];
  if (prev && prev.status === "completed") return; // a finished tour stays finished until it is reset
  data.tours[tourId] = { status: "in_progress", currentStep, totalSteps, completedAt: null };
  write(data);
};

export const completeTour = (tourId, totalSteps) => {
  const data = read();
  data.tours[tourId] = { status: "completed", currentStep: totalSteps, totalSteps, completedAt: new Date().toISOString() };
  write(data);
};

export const resetTour = (tourId) => {
  const data = read();
  delete data.tours[tourId];
  write(data);
};

export const resetAllTours = () => {
  const data = read();
  data.tours = {};
  write(data);
};

export const isWelcomeSeen = () => !!read().welcomeSeen;

export const markWelcomeSeen = () => {
  const data = read();
  data.welcomeSeen = true;
  write(data);
};
